import { render, staticRenderFns } from "./login_page.vue?vue&type=template&id=68f3e290&scoped=true"
import script from "./login_page.vue?vue&type=script&lang=js"
export * from "./login_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3e290",
  null
  
)

export default component.exports